module.exports = __webpack_public_path__ + "static/profile-a9b6770f0e8e7360091f7b5921536d1f.jpg";